import _defineProperty from "/Users/laurogripa/code/kusama/kappasigmamu.github.io/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { extractAuthor } from './util.js';
export function createHeaderExtended(registry, header, validators, author) {
  // an instance of the base extrinsic for us to extend
  const HeaderBase = registry.createClass('Header');
  class Implementation extends HeaderBase {
    constructor(registry, header, validators, author) {
      super(registry, header);
      _defineProperty(this, "__internal__author", void 0);
      this.__internal__author = author || extractAuthor(this.digest, validators || []);
      this.createdAtHash = header === null || header === void 0 ? void 0 : header.createdAtHash;
    }
    /**
     * @description Convenience method, returns the author for the block
     */
    get author() {
      return this.__internal__author;
    }
  }
  return new Implementation(registry, header, validators, author);
}